import { useTheme } from "styled-components";

type SelectColors = {
  backgroundColor: string;
  color: string;
  boxShadow: string;
  hoverBG: string;
  hoverBo: string;
};

export default function useSelectColors(
  open: boolean,
  filled: boolean
): SelectColors {
  const theme = useTheme();
  let backgroundColor: string,
    color: string,
    boxShadow: string,
    hoverBG: string,
    hoverBo: string;

  if (open) {
    backgroundColor = theme.colors.white;
    boxShadow = "0px 2px 4px #4C4C4C24";
    hoverBG = theme.colors.white;
    hoverBo = `1px solid ${theme.colors.grays4}`;
  } else {
    backgroundColor = theme.colors.grays9;
    boxShadow = "0px";
    hoverBG = theme.colors.misc3;
    hoverBo = `1px solid ${theme.colors.grays3}`;
  }
  if (filled) {
    color = theme.colors.grays1;
  } else {
    color = theme.colors.grays3;
  }

  return {
    backgroundColor,
    color,
    boxShadow,
    hoverBG,
    hoverBo,
  };
}
